/**
 * Stores UTM parameters in sessionStorage for submission through
 * Salesforce contact forms. Form logic controlled in contact-form.js.
 */
const captureUtmParams = () => {
  /**
   * Check if the current URL has UTM parameters. If not, return.
   */
  const searchString = window.location.search.toLowerCase();
  if (searchString.length === 0) return;

  /**
   * Check if UTM params have already been captured for this session.
   * If so, return.
   */
  const hasStoredParams = sessionStorage.getItem('utmParams');
  if (hasStoredParams) return;

  /**
   * Check the URL's search params for valid UTM params. Return if none.
   *
   * If valid UTM params are found, store them in sessionStorage.
   */
  const searchParams = new URLSearchParams(searchString);

  let utmParams = {};

  /**
   * If page visit is from a Google Ad (gclid), store generic UTM
   * params for Google Ads. Otherwise, look for actual UTM params.
   */
  if (searchParams.get('gclid')) {
    utmParams.utm_source = 'google';
    utmParams.utm_medium = 'cpc';
    utmParams.utm_campaign = 'google_ad';
  } else {
    const validUtmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    validUtmParams.forEach(param => {
      const value = searchParams.get(param);
      if (!value) return;
      utmParams[param] = value;
    });
  }

  if (Object.keys(utmParams).length === 0) return;

  sessionStorage.setItem('utmParams', JSON.stringify(utmParams));
};

export default captureUtmParams;
